<template>
  <label class="c-label" :for="name">
    {{ label }}
  </label>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
    }
  }
}
</script>

<style lang="scss" scoped>
.c-label {
  position: relative;
  color: #bc284a;
  text-align: start;
  font-size: 16px;
  font-weight: bold;
  padding: 0 0 5px 10px;
  margin: 0;
  width: 100%;
  display: block;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background: #bc284a;
  }
}
</style>